import { Spacing, Text, Title } from '@vkontakte/vkui';
import React, { useEffect } from 'react';
import { isControlFreemium, isHardFreemium } from 'reactApp/appHelpers/featuresHelpers/features/freemium';
import { Dialog } from 'reactApp/ui/Dialog/Dialog';
import { sendDwh } from 'reactApp/utils/ga';

import styles from './FreemiumAboutModal.css';

interface AboutModalProps {
    title: string;
    text: string;
}

const AboutConfig: Array<AboutModalProps> = [
    {
        title: 'Что будет, когда пробный период закончится?',
        text: isControlFreemium
            ? 'Подписка автоматически продлится ещё на один месяц – тот же тариф на 256 ГБ'
            : 'Подписка просто перестанет быть активной. Никакого автопродления не будет, поскольку для пробного периода не нужно привязывать банковскую карту',
    },
    {
        title: 'Что будет с файлами, когда закончится действие пробного периода?',
        text: 'Фото и видео с телефона, загруженные с безлимитом, начнут учитываться в рамках бесплатного объёма (8 ГБ). Если продлить действие подписки до окончания пробного периода, файлы останутся в безлимите',
    },
    {
        title: 'Как продлить подписку после окончания пробного периода и сколько она будет стоить?',
        text: isControlFreemium
            ? 'Подписка автоматически продлится на следующий месяц. Семейный тариф на 256 ГБ стоит 449 ₽ в месяц'
            : 'Подписку можно продлить и во время пробного периода, и после. Первые три месяца семейный тариф на 256 ГБ стоит 349 ₽, далее — 449 ₽ в месяц',
    },
];

export const FreemiumAboutModal = ({ onClose }) => {
    const dwhName = isControlFreemium
        ? 'family_unlimited_info_trial_info_period'
        : isHardFreemium
        ? 'family_unlimited_info_hard_freemium_info_period'
        : 'family_unlimited_info_soft_freemium_info_period';

    useEffect(() => {
        sendDwh({
            eventCategory: 'modal',
            action: 'show',
            dwhData: { name: dwhName },
            dwh_enabled: true,
        });
    }, []);

    const onCloseWrapper = () => {
        sendDwh({
            eventCategory: 'modal',
            action: 'close',
            dwhData: { name: dwhName },
            dwh_enabled: true,
        });
        onClose?.();
    };

    return (
        <Dialog open header={''} closable onCancel={onCloseWrapper} className={styles.root}>
            {AboutConfig.map(({ title, text }, index) => (
                <div key={index}>
                    <Title level="3">{title}</Title>
                    <Spacing size={8} />
                    <Text>{text}</Text>
                </div>
            ))}
        </Dialog>
    );
};
